import React from "react";
import { LeadData } from "../../../src/types";

const OverviewSection: React.FC<{ lead: LeadData }> = ({ lead }) => {
  return (
    <div
      className="mt-6 bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-gray-600 shadow-sm p-4 rounded-lg transition-colors duration-300"
      style={{ fontFamily: "Lato, sans-serif", fontWeight: "normal" }}
    >
      <h3 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white/90">Overview</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Name
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.name || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Email
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.email || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Mobile Number
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.contact || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Source
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.source || "N/A"}</p>
        </div>
         <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Stage
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.stage || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Status
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.status || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Company Name
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.company_name || "N/A"}</p>
        </div>
                <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Company Website
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.company_website || "N/A"}</p>
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Primary Address
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.address || "N/A"}</p>
        </div>
        
        
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Opportunity Amount
          </strong>
          <p className="text-theme-sm text-black dark:text-white">
            {lead.opportunity_amount !== undefined &&
              lead.opportunity_amount !== null
              ? `₹ ${Number(lead.opportunity_amount).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
              : "N/A"}
          </p>
          
        </div>
        <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Referred By
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.referred_by || "N/A"}</p>
        </div>
        {/* <div>
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Assigned To
          </strong>
          <p className="text-theme-sm text-black dark:text-white">{lead.assigned_user_name || "N/A"}</p>
        </div> */}
       
        

        
        
        <div>
          <strong className="text-sm font-medium text-gray-500 dark:text-gray-400">
            Activity Log
          </strong>
          {lead.log ? (
            lead.log.split(" | ").map((line, index) => (
              <p key={index} className="text-theme-sm text-black dark:text-white">
                {line}
              </p>
            ))
          ) : (
            <p className="text-theme-sm text-black dark:text-white">No logs available</p>
          )}
        </div>
        <div className="lg:col-span-3">
          <strong className="text-gray-500 dark:text-gray-400 text-sm font-medium">
            Description
          </strong>
          <p
            className="text-theme-sm text-black dark:text-white text-justify"
            style={{ textAlign: "justify" }}
          >
            {lead.description || "N/A"}
          </p>
        </div>


      </div>
    </div>
  );
};

export default OverviewSection;